import { render, staticRenderFns } from "./occupancy-product.vue?vue&type=template&id=5ba4946c&scoped=true&"
import script from "./occupancy-product.vue?vue&type=script&lang=js&"
export * from "./occupancy-product.vue?vue&type=script&lang=js&"
import style0 from "./occupancy-product.vue?vue&type=style&index=0&id=5ba4946c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba4946c",
  null
  
)

export default component.exports